import { MeModel, QueriesClient } from "@app/api2/api";
import { accountClient, queriesClient } from "@app/api2/Clients";
import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { AppRoutes, buildUrl } from "../AppRoutes";
import BPUnexpectedError from "../Common/BPUnexpectedError";

export interface UserContextType {
  user: MeModel | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<any>;
  logoutAndRedirectToLogin: () => Promise<void>;
}

export const UserContext = createContext<UserContextType>({
  user: null,
  loading: true,
  error: null,
  refresh: () => Promise.resolve(),
  logoutAndRedirectToLogin: () => Promise.resolve(),
});

// Custom hook to use the UserContext
export const useUser = () => useContext(UserContext);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // const userClient = new QueriesClient();

  const query = useQuery({
    queryKey: ['user', 'me'],
    queryFn: async () => {
      try {
        const response = await queriesClient.getMe2();
        return response;
      } catch (error) {
        // console.error('Error fetching user data:', error);
        return { lab: {}, details: { name: 'Unauthenticated' } } as MeModel;
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    // onError: (error: any) => {
    //   // On any error (auth, network, etc.), ensure user is set to null
    //   console.error('User fetch error:', error);
    // },
    // retry: (failureCount, error: any) => {
    //   // Don't retry on authentication/authorization errors (401, 403)
    //   if (error?.status === 401 || error?.status === 403) {
    //     return false;
    //   }
    //   // Retry up to 2 times for other errors
    //   return failureCount < 2;
    // },
  });

  const contextValue: UserContextType = {
    user: query.error ? null : (query.data || null), // Set user to null on any error
    loading: query.isLoading,
    error: query.error ? (query.error as any).message || "Unknown error" : null,
    refresh: query.refetch,
    logoutAndRedirectToLogin: async () => {
      await accountClient.logout();
      window.location.href = buildUrl(AppRoutes.Login, {});
      // query.refetch();
    }
  };

  if (query.isLoading) {
    return null; // Or a loading spinner
  }
  if (query.isError) {
    return <BPUnexpectedError />;
  }

  return (
    <UserContext.Provider value={contextValue}>
      {query.data == null ? null : children}
    </UserContext.Provider>
  );
};